<button type="button" class="btn btn-primary pull-right mb-3" (click)="addTenancy()">
    <ng-content></ng-content>
</button>
